export const init = {
  status: false,
  isLoading: false,
  isEdit: false,
  isCheck: false,
  isStatus: true,
  expireToken: false,
  data: false,
};
